import { useEffect, useState } from "react";

const SHORTCUTS = [
  { keys: "⌘/Ctrl + K", action: "Global search" },
  { keys: "?", action: "Show this help" },
  { keys: "g then d", action: "Dashboard" },
  { keys: "g then t", action: "Time tracking" },
  { keys: "g then p", action: "Time off" },
  { keys: "g then c", action: "Chat" },
  { keys: "g then s", action: "SOPs" },
  { keys: "g then h", action: "Handbook" },
  { keys: "g then r", action: "Resources" },
  { keys: "g then b", action: "Boards" },
  { keys: "g then x", action: "My production" },
  { keys: "g then u", action: "My profile" },
];

export function ShortcutHelp() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const h = () => setOpen(o => !o);
    const esc = (e: KeyboardEvent) => { if (e.key === "Escape") setOpen(false); };
    document.addEventListener("scenta-shortcut-help", h);
    window.addEventListener("keydown", esc);
    return () => {
      document.removeEventListener("scenta-shortcut-help", h);
      window.removeEventListener("keydown", esc);
    };
  }, []);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[90] flex items-center justify-center bg-ink/60 p-4" onClick={() => setOpen(false)}>
      <div className="card w-full max-w-md" onClick={e => e.stopPropagation()}>
        <div className="mb-3 flex items-center justify-between">
          <h2 className="text-lg font-semibold">Keyboard shortcuts</h2>
          <button onClick={() => setOpen(false)} className="text-gray2">×</button>
        </div>
        <table className="w-full text-sm">
          <tbody>
            {SHORTCUTS.map(s => (
              <tr key={s.keys}>
                <td className="py-1.5 pr-4"><kbd className="rounded bg-offwhite px-2 py-0.5 font-mono text-xs">{s.keys}</kbd></td>
                <td className="py-1.5">{s.action}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <p className="mt-3 text-xs text-gray2">Press <kbd className="rounded bg-offwhite px-1.5 py-0.5">?</kbd> any time to see this.</p>
      </div>
    </div>
  );
}
